export default __webpack_public_path__ + "static/media/5.391c543f.png";